// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddFormFieldOptionMutation($input: AddFormFieldOptionInput!) {
    addFormFieldOption(input: $input) {
      formField {
        id
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
